// extracted by mini-css-extract-plugin
export default {"container":"MemberNameMinimized__container--mcatv","muted":"MemberNameMinimized__muted--GFQz6","name":"MemberNameMinimized__name--cBtKt"};